module.exports = __webpack_public_path__ + "images/embed/write_doc.gif";